// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { lang as english } from './localization/lang';
import { french } from './localization/lang.fr';
import { german } from './localization/lang.de';


i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: french },
    en: { translation: english },
    de: { translation: german },
  },
  lng: 'fr', // default language
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, 
  },
});

export default i18n;
